var $ = require('@alife/alpha-jquery/jquery');

var Manager = {
    /**
     * 当前起始的zIndex
     */
    beginZIndex : 1000,
    /**
     * 所有Overlay的实例
     */
    allOverlays : [],
    /**
     * 所有点击需要隐藏的Overlay的实例
     */
    blurOverlays : [],


    addOverlay: function(overlay, hidden){
//        var currentZIndex = this.getCurrentOverlayZIndex(),
//            zIndex = parseInt(overlay.element.css('zIndex'), 10);

//        if(isNaN(zIndex)){
//            zIndex = 0;
//        }
//        if(zIndex <= currentZIndex){
//            overlay.element.css('zIndex', currentZIndex + 1);
//        }
        this.allOverlays.push(overlay);
        if(hidden){
            this.blurOverlays.push(overlay);
        }
    },

    /**
     * 获取当前focused的overlay的zIndex层级，
     * 以免其他浮层的zIndex值过低，导致显示出现问题
     * @return {Int}
     */
    getCurrentOverlayZIndex : function() {
        var currentOverlay = this.getCurrentOverlay(),
            zIndex;

        if(currentOverlay){
            zIndex = currentOverlay.element.css('zIndex');
        }

        if(typeof zIndex == 'number'){
            return zIndex;
        }
        return this.beginZIndex;
    },
    /**
     * 获取当前focused的overlay
     * @return {Overlay}
     */
    getCurrentOverlay : function() {
        var current;
        this.allOverlays.forEach(function(overlay) {
            if(overlay.get('focused')) {
                current = overlay;
            }
        });
        return current;
    },
    hideBlurOverlays : function(e) {
        this.blurOverlays.forEach(function(overlay) {
            if(overlay.get('visible')) {
                for(var i = 0; i < overlay._relativeElements.length; i++){
                    var el = $(overlay._relativeElements[i])[0];
                    if(el === e.target || $.contains(el, e.target) || !$.contains(document, e.target)) {
                        return;
                    }
                }
                overlay.hide();
            }
        });
    },
    /**
     * overlay销毁的时候，从当前缓存中删除这个overlay
     * @param overlay {Overlay} 需要删除的overlay
     */
    removeOverlay: function(overlay){
        var i = this.allOverlays.indexOf(overlay),
            index = this.blurOverlays.indexOf(overlay);

        this.allOverlays.splice(i ,1);
        this.blurOverlays.splice(index, 1);
    }
};

$(document).on('click', function(e){
    Manager.hideBlurOverlays(e);
});

var timeout;
var winWidth = $(window).width();
var winHeight = $(window).height();

$(window).on('resize', function(){
    timeout && clearTimeout(timeout);
    timeout = setTimeout(function() {
        var winNewWidth = $(window).width();
        var winNewHeight = $(window).height();

        // IE678 莫名其妙触发 resize
        // http://stackoverflow.com/questions/1852751/window-resize-event-firing-in-internet-explorer
        if (winWidth !== winNewWidth || winHeight !== winNewHeight) {
            Manager.allOverlays.forEach(function(overlay){
                if(overlay.get('visible')){
                    overlay.setPosition();
                }
            });
        }

        winWidth = winNewWidth;
        winHeight = winNewHeight;
    }, 80);
});

module.exports = Manager;